import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { FormGroup, Label, Input as ReactStrapInput } from 'reactstrap';
import Octicon, { Check } from '@githubprimer/octicons-react';
import { toKebabCase } from '~/util/StringUtil';

type SimpleCheckBoxProps = FieldRenderProps<string, HTMLInputElement> & {
	label: string;
};

class SimpleCheckBox extends React.Component<SimpleCheckBoxProps> {
	constructor(props) {
		super(props);
	}

	public render() {
		const {
			input: { name, onChange, onBlur, onFocus, checked },
			meta,
			label,
			type = 'checkbox',
			disabled,
			autoFocus,
		} = this.props;

		return (
			<FormGroup>
				<Label for={name} className="fancy-checkbox">
					<ReactStrapInput
						id={name}
						name={name}
						className="fancy-checkbox__checkbox"
						type={type}
						checked={checked}
						onChange={onChange}
						disabled={disabled}
						autoFocus={autoFocus}
						invalid={!meta.dirtySinceLastSubmit && meta.submitError ? true : false}
						onBlur={onBlur}
						onFocus={onFocus}
					/>

					<span className="fancy-checkbox__box" data-testid={`checkbox-${toKebabCase(name)}`}>
						{checked ? <Octicon icon={Check} ariaLabel="Checkmark" /> : null}
					</span>
					<span className="fancy-checkbox__text" data-testid={`checkbox-${toKebabCase(label)}`}>
						{label}
					</span>
				</Label>
			</FormGroup>
		);
	}
}

export default SimpleCheckBox;
